module.exports = __webpack_public_path__ + "img/Icon-Facebook.e85ce1b9.svg";